export const environment = {
  production: false,
  apiUrl: 'https://apiv3.plataformaasap.com.br',
  baseUrl: 'https://apiv3.plataformaasap.com.br',
  pageEditorUrl: 'https://page.hmgasap.com.br/',
  filestack: {
    key: 'AD5oDjsJaTJOzLe1Llj9mz'
  },
  pusher: {
    key: 'eaf41725f3b027147953',
  },
  firebase: {
    apiKey: 'AIzaSyCnQ7hg9qn8mrS3zSLX-xeXX3wKbuC2GXA',
    authDomain: 'admin-17e4f.firebaseapp.com',
    databaseURL: 'https://admin-17e4f.firebaseio.com',
    projectId: 'admin-17e4f',
    storageBucket: 'admin-17e4f.appspot.com',
    messagingSenderId: '572223664609'
  },
  firebaseApp: {
    "21": {
      apiKey: "AIzaSyBo6x5MLjGIjrAgzzRbOX4rTmVqhpNqSmU",
      authDomain: "lab-60.firebaseapp.com",
      databaseURL: "https://lab-60.firebaseio.com",
      projectId: "lab-60",
      storageBucket: "lab-60.appspot.com",
      messagingSenderId: "915042152208"
    },
    "3": {
      apiKey: "AIzaSyDpcFrHt_pPei3MkccLM011LaeCrdrI8Vo",
      authDomain: "asta-e860d.firebaseapp.com",
      databaseURL: "https://asta-e860d.firebaseio.com",
      projectId: "asta-e860d",
      storageBucket: "asta-e860d.appspot.com",
      messagingSenderId: "576204749170"
    },
    "6": {
      apiKey: "AIzaSyBKcK1gvm7NZPR69lSyWGkjHPzG4_E52T8",
      authDomain: "fitneink.firebaseapp.com",
      databaseURL: "https://fitneink.firebaseio.com",
      projectId: "fitneink",
      storageBucket: "fitneink.appspot.com",
      messagingSenderId: "643874255045"
    }
  },
  language: 'pt-br'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts